import React from 'react';
import { Check } from 'lucide-react';
const systemPoints = ['nach Klassenstufen geordnet', 'für ein ganzes Schuljahr strukturiert', 'sofort nutzbar', 'praxisnah', 'druckbar', 'für echte Schulsituationen gemacht'];
export function DifferentiatorSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-67">
      <div className="max-w-3xl mx-auto text-center" data-id="element-68">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-6" data-id="element-69">
          Was macht SPORTUNTERRICHT FERTIG anders?
        </h2>
        <p className="text-text-sec text-base sm:text-lg font-medium leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-70">
          Viele Materialien im Internet sind einzelne Übungen, lose Spiele oder
          isolierte Arbeitsblätter. SPORTUNTERRICHT FERTIG ist anders — es ist
          ein komplettes System:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-2xl mx-auto mb-10 text-left" data-id="element-71">
          {systemPoints.map((point, i) => <div key={i} className="bg-bg-main rounded-2xl p-4 sm:p-5 border border-border-light flex items-center gap-3 shadow-sm" data-id="element-72">
              <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-73">
                <Check className="w-3.5 h-3.5 text-primary" data-id="element-74" />
              </span>
              <span className="text-text-main font-medium text-sm sm:text-base" data-id="element-75">
                {point}
              </span>
            </div>)}
        </div>

        <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold max-w-2xl mx-auto" data-id="element-76">
          Du bekommst nicht nur Ideen. Du bekommst einen fertigen
          Unterrichtsrahmen.
        </p>
      </div>
    </section>;
}